import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import Schedule from '@/types/table/schedule';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ScheduleData extends Schedule {
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ScheduleController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ScheduleData>>(
      API_CONTEXT + '/upms/schedule/list',
      params,
      httpOptions,
    );
  }

  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ScheduleData>(API_CONTEXT + '/upms/schedule/view', params, httpOptions);
  }

  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/upms/schedule/export', params, fileName);
  }

  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/upms/schedule/import', params);
  }

  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/upms/schedule/print', params);
  }

  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/schedule/add', params, httpOptions);
  }

  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/schedule/update', params, httpOptions);
  }

  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/schedule/delete', params, httpOptions);
  }

  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/upms/schedule/deleteBatch', params, httpOptions);
  }
}
